import React, { useState } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import userStore from '../../store/userStore';
import AircallPhones from './components/AircallPhones';
import WhatsAppRecobro from './components/WhatsAppRecobro';
import GmailSettings from './components/GmailSettings';
import KapsoSettings from './components/KapsoSettings';
import EmailSettings from './components/email/EmailSettings';
import CallsSettings from './components/CallsSettings';
import SmsSettings from './components/SmsSettings';
import SettingsNav from './components/SettingsNav';
import { esCanalValido, CANAL_POR_DEFECTO } from './channels';

const SettingsPage = () => {
  const user = userStore(state => state.user);
  const [searchParams] = useSearchParams();
  const pedido = searchParams.get('tab');
  // Un `?tab=` inventado —o de un canal aún sin construir— no puede dejar la
  // pantalla en blanco.
  const [activeTab, setActiveTab] = useState(
    esCanalValido(pedido) ? pedido : CANAL_POR_DEFECTO
  );

  if (user.role !== 'admin') {
    return <Navigate to='/dashboard' replace />;
  }

  return (
    <MainLayout>
      <div className='space-y-6'>
        <div className='flex gap-6'>
          <div className='w-56 flex-shrink-0'>
            <SettingsNav activo={activeTab} onSelect={setActiveTab} />
          </div>

          <div className='flex-1 space-y-6'>
            {activeTab === 'kapso' && <KapsoSettings />}
            {activeTab === 'resend' && <EmailSettings />}
            {activeTab === 'ar-calls' && <CallsSettings />}
            {activeTab === 'maytapi' && <WhatsAppRecobro />}
            {activeTab === 'aircall' && <AircallPhones />}
            {activeTab === 'gmail' && <GmailSettings />}
            {activeTab === 'sms' && <SmsSettings />}
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default SettingsPage;
